import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormGroup, FormControlLabel, Checkbox } from '@material-ui/core';
import _ from 'lodash';
import { IsEmpty } from '../../../common/checks';
import Constants from '../../../common/constants';

const MealsAvailableTag = (props) => {
  const [selected, setSelected] = useState([]);
  const optionList = Constants.MealTags;
  const [active, setActive] = useState(false);
  let tempArr = [];

  useEffect(() => {
    setActive(props.mealsAvailFlag);
    props.onSkipTag(props.mealsAvailFlag);
  }, [props.mealsAvailFlag]);

  useEffect(() => {
    if (!IsEmpty(props.tags)) {
      _.map(props.tags, (tag) => {
        if (optionList.includes(tag)) {
          tempArr.push(tag);
        }
      });
      setSelected(tempArr);
    }
  }, [props.tags]);

  const onChange = (tag) => {
    if (!IsEmpty(tag)) {
      if (!selected.includes(tag)) {
        setActive(false);
        tempArr = _.concat(selected, tag);
      } else {
        setActive(false);
        tempArr = _.without(selected, tag);
      }
      props.onSkipTag(false);
      props.updateTags(tempArr);
      setSelected(tempArr);
    }
  };

  const clearTags = () => {
    setActive(!active);

    if (!IsEmpty(selected) || !active) {
      setSelected([]);
      props.updateTags([]);
      props.onSkipTag(true);
    } else {
      props.onSkipTag(false);
    }
  };

  return (
    <>
      { selected && optionList.map((t) => (
        <div style={{ display: 'inline-block', width: 175 }} key={t}>
          <FormGroup>
            <FormControlLabel control={<Checkbox value={t} name={t} checked={props.tags.includes(t)} />} label={_.capitalize(t)} onChange={(e) => onChange(e.target.value)} />
          </FormGroup>
        </div>
      ))}

      <div style={{ display: 'inline-block', width: 250 }}>
        <FormGroup>
          <FormControlLabel control={<Checkbox checked={active} />} label="Not Applicable" onChange={() => clearTags()} />
        </FormGroup>
      </div>
    </>
  );
};
MealsAvailableTag.propTypes = {
  mealsAvailFlag: PropTypes.bool,
  tags:           PropTypes.arrayOf(PropTypes.string),
  updateTags:     PropTypes.func.isRequired,
  onSkipTag:      PropTypes.func.isRequired,
};

MealsAvailableTag.defaultProps = {
  tags:           [],
  mealsAvailFlag: false,
};

export default connect(null, null)(MealsAvailableTag);
